import React, { ReactElement, useEffect, useState } from 'react';
import { BarLoader } from 'react-spinners';
import {
  IOptionGlobal,
  LeagueLiveType,
  LiveAllDisplay,
  MethodLiveType,
  VoiceLiveType,
} from '../../common/constants/globalConstants';
import { useGetListLiveMutation } from '../../services/api/apiService/liveApiService';
import { IResponseLive } from '../../services/api/models/response/responseLive';
import { LiveBlock } from '../live/components/LiveBlock/LiveBlock';
import './LiveFollowerList.scss';

export const LiveFollowerList = (): ReactElement => {
  const [getListLive] = useGetListLiveMutation();
  const [followingLiveData, setFollowingLiveData] = useState<IResponseLive[]>();
  const [loading, setLoading] = useState<boolean>();
  const [option, setOption] = useState<IOptionGlobal>({
    numOfPage: 0,
    numInPage: LiveAllDisplay,
  });

  useEffect(() => {
    getLiveFollowData();
  }, []);

  const getLiveFollowData = async () => {
    setLoading(true);
    const data = await getListLive({
      numOfPage: option.numOfPage,
      numInPage: option.numInPage,
      method: MethodLiveType.FOLLOW,
      league: LeagueLiveType.ANY,
      voice: VoiceLiveType.ANY,
    }).unwrap();
    setFollowingLiveData(data);
    setLoading(false);
  };
  return (
    <div className="live-follower-list box-shadow-3">
      <span className="live-follower__title">フォロー中</span>

      {loading && <BarLoader color={'#0275d8'} width="100%"></BarLoader>}

      {(followingLiveData?.length === 0 || followingLiveData === undefined) && (
        <div className="block-group__empty">
          <p style={{ opacity: 0.5 }}>データなし</p>
        </div>
      )}

      {followingLiveData?.map((live) => {
        return (
          <div key={live.id} className="live-follower__item">
            <LiveBlock live={live} />
          </div>
        );
      })}
    </div>
  );
};
